import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import "../../Assets/styles/customPhoneSelect.css";
import "react-phone-number-input/style.css";
import { ReactComponent as GenericAvatar } from "../../Assets/iconsv2/generic/GenericAvatar.svg"
import { useTranslate } from '@tolgee/react';
import PhoneInput from "react-phone-number-input";
import DeleteConfirmationChild from "../GenericComponents/DeleteConfirmationChild";
import PrimaryButtonRemove from "../GenericComponents/PrimaryButtonRemove";
import { displayAvatar, displayUserAvatar } from "../../Helpers/chatHelper/AvatarHelper";
import { ReactComponent as ProIcon } from "../../Assets/iconsv2/generic/PremiumUser.svg"
import { ReactComponent as PlatformIcon } from "../../Assets/iconsv2/generic/BusinessUser.svg"
import { ReactComponent as PlatformIconLight } from "../../Assets/iconsv2/generic/BusinessUserLight.svg"

import { ReactComponent as CallIcon } from "../../Assets/iconsv2/generic/Phone.svg"
import { ReactComponent as ChatIcon } from "../../Assets/iconsv2/generic/messageIconEmpty.svg"
import { ReactComponent as VideoIcon } from "../../Assets/iconsv2/generic/Video.svg"

import { ReactComponent as Close } from "../../Assets/iconsv2/generic/closeBtn.svg"
import { useGenericComponentsStateService } from "../../Context/GenericComponentsStateContext";

const ContactDetailsView = ({
  contact,
  handleBlockContact,
  handleUnblockContact,
  closeAction,
  callAction,
  chatAction
}) => {


  const profileAvatarRef = useRef();
  const [previewAvatar, setPreviewAvatar] = useState(contact.profile_picture);
  const [avatar, setAvatar] = useState(contact.profile_picture);
  const [name, setName] = useState(contact.name);
  const [about, setAbout] = useState(contact.about);
  const [phone, setPhone] = useState(contact?.phone_number);
  const [blocked, setBlocked] = useState(contact?.blocked)
  const [openUnblockModal, setOpenUnblockModal] = useState(false);
  const [openBlockModal, setOpenBlockModal] = useState(false);
  const { theme } = useGenericComponentsStateService();

  const handleAvatarChange = (e) => {
    setAvatar(e.target.files[0])
    setPreviewAvatar(URL.createObjectURL(e.target.files[0]));
  };

  useEffect(() => {
    setPreviewAvatar(contact.profile_picture)
    setAvatar(contact.profile_picture)
    setName(contact.name)
    setAbout(contact.about)
    setPhone(contact?.phone_number)
    setBlocked(contact?.blocked)
  }, [contact])
  const { t } = useTranslate();
  return (
    <AddNewGroupContainer>
      <Header>
        <HeaderTitle>{t('general.details')}</HeaderTitle>
        <ActionsWrapper>
          {chatAction && <ChatIcon onClick={(e) => { e.stopPropagation(); chatAction(contact) }} />}
          {callAction && <VideoIcon onClick={(e) => { e.stopPropagation(); callAction(contact, true) }} />}
          {callAction && <CallIcon onClick={(e) => { e.stopPropagation(); callAction(contact, false) }} />}
          {closeAction &&
            <CloseButton onClick={() => closeAction()}>
              <Close />
            </CloseButton>
          }
        </ActionsWrapper>

      </Header>
      <DetailsWrapper>


        <Group>
          <TitleWrapper>
            <h1>{t('chat_details.user_details')}</h1>
          </TitleWrapper>

          <OptionWrapper>
            <ProfileDetails>
              <UserWrapper>
                <input
                  type="file"
                  hidden
                  accept=".png, .jpg, .jpeg "
                  ref={profileAvatarRef}
                  onChange={(e) => handleAvatarChange(e)}
                />
                <UserAvatarWrapper>
                  <UserAvatar>
                    {displayUserAvatar(contact)}
                  </UserAvatar>
                  <ProBadgeWrapper>
                    {contact.is_pro_from_platform ? (
                      theme === "light" ? <PlatformIconLight /> : <PlatformIcon />
                    ) :
                      contact.is_pro && <ProIcon />
                    }
                  </ProBadgeWrapper>
                </UserAvatarWrapper>
                <CustomNameInput
                  value={name}
                  readOnly
                ></CustomNameInput>
              </UserWrapper>
              {about && about.length > 1 &&
                <AboutWrapper>
                  <CustomNameInput
                    value={about}
                    readOnly
                  ></CustomNameInput>
                </AboutWrapper>}

            </ProfileDetails>
          </OptionWrapper>
        </Group>

        <Group>
          <TitleWrapper>
            <h1>{t('chat_details.account_details')}</h1>
          </TitleWrapper>
          <OptionWrapper>
            {contact.phone_number &&
              <>
                <OptionLabel>
                  <p>{t('profile.phone_number')}</p>
                </OptionLabel>
                <PhoneNumberWrapper>
                  <CustomPhoneWrapper>
                    <PhoneInput
                      readOnly
                      international
                      defaultCountry={"RO"}
                      name="phoneNumber"
                      placeholder={t('profile.phone_number')}
                      value={phone}
                      onChange={(e) => setPhone(e)}
                    />
                  </CustomPhoneWrapper>
                </PhoneNumberWrapper>
              </>
            }
            {contact.email &&
              <>
                <OptionLabel>
                  <p>{t('profile.email')}</p>
                </OptionLabel>
                <AboutWrapper>
                  <CustomInput
                    value={contact.email}
                    readOnly
                  ></CustomInput>
                </AboutWrapper>
              </>
            }


          </OptionWrapper>
        </Group>

        <Group>
          {blocked
            ?
            <DeleteConfirmationChild
              open={openUnblockModal}
              setOpen={setOpenUnblockModal}
              variant={"unblock_contact"}
              action={handleUnblockContact}
              item={contact}

            >

              <PrimaryButtonRemove
                style={{ padding: "16px" }}
                onClick={() => setOpenUnblockModal(true)}
                text={t('block_contacts.unblock').toUpperCase()}
              />

            </DeleteConfirmationChild>

            :

            <DeleteConfirmationChild
              open={openBlockModal}
              setOpen={setOpenBlockModal}
              variant={"block_contact"}
              action={handleBlockContact}
              item={contact}

            >
              <PrimaryButtonRemove
                style={{ padding: "16px" }}
                onClick={() => setOpenBlockModal(true)}
                text={t('block_contacts.block')}
              />

            </DeleteConfirmationChild>
          }

        </Group>
      </DetailsWrapper>
    </AddNewGroupContainer>
  )

};

export default ContactDetailsView;

const AddNewGroupContainer = styled.div`
 background: ${({ theme }) => theme.chat.conversationBackground};
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  height: 100%;
  margin:auto;
  overflow: auto;

`;

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  h1 {
     color:${({ theme }) => theme.menu.infoText};
  font-size: 14px;
    font-weight: 500;
    line-height: 22px;
  text-transform:uppercase;
  }
`;

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding:10px 16px;
    background: ${({ theme }) => theme.menu.groupContentBackground};
  border-radius: 4px;
`;

const ProfileDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

const UserAvatar = styled.div`
  display: flex;
  cursor: pointer;
  height: 42px;
  width: 42px;
`;

const UserWrapper = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  h1 {
    font-size: 20px;
    font-weight: 500;
    line-height: 22px;
    color: ${({ theme }) => theme.menu.primaryTextColor};
  }
`;
const AboutWrapper = styled.div`
display:flex;
padding:10px 0;
`
const CustomInput = styled.input`
width:100%;
  background: none;
  border: none;
  color: ${({ theme }) => theme.menu.primaryTextColor};
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: -0.40799999237060547px;
  &:focus-visible {
    outline: none;
  }
`;

const CustomNameInput = styled(CustomInput)`
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
`;


const UserAvatarWrapper = styled.div`
  position: relative;
`;



const OptionLabel = styled.div`
  display: flex;
  justify-content: space-between;
  
  p {
    color: ${({ theme }) => theme.menu.secondaryTextColor};
    font-size: 12px;
    font-weight: 500;
    line-height: 20px;
  }
`
const CustomPhoneWrapper = styled.div`
   background: ${({ theme }) => theme.menu.groupContentBackground};
  border-radius: 4px;
  display: flex;
  align-items: center;
  width: 100%;
  input {
    padding: 14px 16px;
    color: ${({ theme }) => theme.menu.primaryTextColor};
     background: ${({ theme }) => theme.menu.groupContentBackground};
    border-radius: 10px;
    border: none;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    &:focus {
      outline: none;
    }
  }

  .PhoneInputCountry {
  border: none;
  background: ${({ theme }) => theme.menu.groupContentBackground};
  border: 1px solid ${({ theme }) => theme.sidebar.borderColor};
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  align-self: center;
  margin-right: 0;
}
  .PhoneInput {
  width: 100%;
}
.PhoneInputCountrySelectArrow {
  display: none;
}
.PhoneInputCountryIcon--border {
  box-shadow: none;
}
.PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border {
  box-shadow: none;
}
`;
const PhoneNumberWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;




const Header = styled.div`
display:flex;
justify-content:space-between;
padding: 19px 16px;
align-items:center;
background:${({ theme }) => theme.menu.conversationBackground};
border-bottom:1px solid ${({ theme }) => theme.sidebar.borderColor};
gap:20px;
`
const HeaderTitle = styled.h3`
font-weight: 700;
font-size: 20px;
line-height:32px;
letter-spacing: 0.04px;
color:${({ theme }) => theme.menu.primaryTextColor};
`

const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  margin-left:auto;
  svg{
  height:26px!important;
  width:26px!important;
  color:${({ theme }) => theme.menu.selectedOpionBackground}!important;
  stroke:${({ theme }) => theme.sidebar.borderColor}!important;
  }
`;
const DetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding:0 16px;
  margin:0 auto;
  width:100%;
      max-width:600px;
      `

const ProBadgeWrapper = styled.div`
      display:flex;
      align-items:center;
      justify-content:center;
      position:absolute;
      bottom:-5px;
      right:-3px;
      width:20px;
      height:16px;
      svg{
color:${({ theme }) => theme.loginButton.background};
}
      `

const ActionsWrapper = styled.div`
display: flex;
align-items:center;
cursor:pointer;
gap:8px;

svg{
color:${({ theme }) => theme.menu.selectedTextColor};
width:20px;
height:20px;
}

`